import styled from 'styled-components';
import { CaptionRegularM } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';

export const AddParticipantFormCont = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 376px;
  ${({ theme }: IThemeProvider) => `
       padding: ${theme.layout.spacing.centy} 0 0 56px; 
           `}
`;


interface IFormPartCell {
  theme: ITheme;
  apiError?: boolean;
  type?: 'email'
}
export const FormPartCell = styled.div<IFormPartCell>`
  position: relative;
  display: flex;
  flex-direction: column;
  ${({ theme, apiError, type }: IFormPartCell) => `
    padding: 0 0 ${apiError
    ? type === 'email' ? theme.layout.spacing.mega : theme.layout.spacing.deka
    : theme.layout.spacing.centy} 0;
  `}
`;

export const ControllerCont = styled.div`
  position: relative;
`;

export const Label = styled.span`
  text-align: start;
  position: relative;
  left: 5px;
`;

export const AdditionalLabel = styled(CaptionRegularM)`
  position: absolute;
  right: 18px;
  ${({ theme }: IThemeProvider) => `
            color: ${theme.colors.neutral.primary[50]};
        `}
`;
